const progressBarOptions = {
  failedColor: "#ed1c3a",
};

export default progressBarOptions;
